import React from 'react';
import { motion } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';
import styles from './AdvtFullSize.module.css';

import { BgVideo } from '../BgVideo/BgVideo';

import logo from '../../assets/images/logo.png';

const AdvtFullSize = React.memo(() => {
  const { paddingQR, sizeQR, titleFontSize, qrCode1, qrCode2, title } =
    useGetParams();

  const advtlines = title.split(/\\n/);
  const initDelay = 0.4;

  return (
    <div className={styles.wrapper}>
      <motion.div
        className={styles.logoBlock}
        initial={{ scale: 1 }}
        animate={{
          scale: 0,
          transition: { delay: 4.24, duration: 0.76 },
        }}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{
            scale: [0, 1.13, 1],
            transition: {
              times: [0, 0.6, 1],
              duration: 1.6,
              ease: ['easeOut', 'easeOut'],
            },
          }}
        >
          <img src={logo} alt="" />
        </motion.div>
      </motion.div>

      {advtlines && (
        <motion.div
          className={styles.titleBlock}
          initial={{ y: '80rem' }}
          animate={{ y: 0 }}
          transition={{
            duration: 0.6,
            delay: initDelay + 4.6,
          }}
        >
          {advtlines[0] && (
            <motion.div
              className={styles.title}
              initial={{ scale: 0 }}
              animate={{ scale: [0, 1.13, 1] }}
              transition={{
                times: [0, 0.6, 1],
                duration: 1.6,
                ease: ['easeOut', 'easeOut'],
                delay: initDelay,
              }}
            >
              {advtlines[0]}
            </motion.div>
          )}
        </motion.div>
      )}

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: initDelay + 5.2,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: initDelay + 5.6,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode1" />
          </motion.div>
        )}
      </div>

      <motion.div
        initial={{ y: '20rem', opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: initDelay + 5.4 }}
        className={styles.extraText}
      >
        Присылай свой вариант
      </motion.div>

      <BgVideo />
    </div>
  );
});

export default AdvtFullSize;
